module.exports = __webpack_public_path__ + "assets/img/10-1.45ab8f16.png";